// ==============================|| APP IDENTITY (SURF-GATE) ||============================== //

import type { AppCode } from '@zercode/auth';

/**
 * WHICH SPA this bundle is. ONE home per app — the root `<ProtectedRoute requiredApp>` and
 * `useLandingRoute` both read it, so the app can never disagree with itself about its own identity.
 *
 * ⚠ ITS OWN MODULE, DELIBERATELY NOT `lib/zercode.ts`. That module holds the API clients, so ~40 test
 * files stub it with `vi.mock('../../lib/zercode', () => ({ …just the client I need… }))`. A constant
 * living there is invisible to those factories, and any test whose import graph reaches the landing
 * hook dies at collection with "No APP_CODE export is defined on the mock" — which happened, in
 * `teacher/SidebarBottom.test.tsx`, for exactly this reason. Nothing mocks this file.
 *
 * ⚠ `satisfies AppCode`, NOT `: AppCode`. An annotation would WIDEN the type to the 4-way union, and
 * `landingPathsOf`/`LANDING_CATALOG` take the NARROWER `LandingApp` ('admin' | 'student' | 'teacher',
 * no super-admin) — so the landing hook would stop compiling and the obvious fix would be a cast,
 * i.e. a lie. `satisfies` checks the value against the registry and keeps the literal.
 */
export const APP_CODE = 'admin' as const satisfies AppCode;
